<template>
    <sa-page-layout :btnBackVisible="true" :btnEditVisible="btnEditVisible" :linkback="linkback" :linkedit="linkedit" :pathResource="pathResource" :showModalLoading="showModalLoading" :btnPrintVisible="false" :linkPrintData="linkPrintData">
        <template slot="toolbar">
            <!--    <b-button size="sm" variant="btn--md btn-light waves-effect waves-light btn-toolbar  float-sm-right" @click="loadStampeReport">
                <b-icon icon="printer"></b-icon>
                Stampa
            </b-button> -->
            <print-component :documentRepository="true" :idRisorsa="idRisorsa"> </print-component>
        </template>
        <template slot="table-body">
            <rsa-accettazione-view-component ref="cmpRsaAccettazioneViewComponent" @beforeLoadData="onBeforeloadData" @afterLoadData="onAfterLoadData" @updateIdDocumentRepository="onUpdateIdDocumentRepository" :isViewMode="true"></rsa-accettazione-view-component>
        </template>
    </sa-page-layout>
</template>
<script>
import SaPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
import RsaAccettazioneViewComponent from "../components/RsaAccettazioneViewComponent.vue";
import UtilityMixin from "../../../utility/UtilityMixin";
import PrintComponent from "../../../utility/components/PrintComponent.vue";

export default {
    components: { SaPageLayout, RsaAccettazioneViewComponent, PrintComponent },
    mixins: [UtilityMixin],
    data() {
        return {
            btnNewVisible: false,
            pathResource: "/rsaaccettazioni",
            id: null,
            btnEditVisible: true,
            linkedit: null,
            linkback: "/rsaaccettazione",
            linkPrintData: "",
            showModalLoading: false,
            listKey: 0,
            idRisorsa: null,
        };
    },
    mounted() {
        let me = this;
        me.id = this.$route.params.id;
        me.idRisorsa = me.id;
        me.linkedit = "/rsaaccettazione/edit/" + me.id;
        me.linkPrintData = "/rsaaccettazioni/print/" + me.id;
        this.$refs.cmpRsaAccettazioneViewComponent.setId(me.id);
    },
    methods: {
        onUpdateJsonData(data) {
            let me = this;
            me.jsonData = data;
        },
        onAfterLoadData() {
            let me = this;
            me.showModalLoading = false;
        },
        onBeforeloadData() {
            let me = this;
            me.showModalLoading = true;
        },
        loadStampeReport() {
            let me = this;
            me.loadDataResources(me.pathResource + "/printdata/" + me.id, null, me.resultResponseStampa, me.resultErrorStampa);
        },
        resultResponseStampa(response) {
            let me = this;
            me.reportName = response.data.data.reportName;
            me.printData = response.data.data;
            me.$refs.cmpPrint.print(response.data.data);
        },
        resultErrorStampa(error) {
            console.log(error);
        },
        onUpdateIdDocumentRepository(id) {
            let me = this;
            me.idRisorsa = id;
        },
    },
};
</script>
<style></style>
